module.exports = __webpack_public_path__ + "img/thumbnail_AfricanCrestedPorcupine_j_albino.6f1b8d36.png";